import produce, { setAutoFreeze } from 'immer';

// temporary solution for removing print pdf button. will be removed after css conflicts with formula are resolved

setAutoFreeze(false)

export const CustomConfirm = ({ children }) => {
  return produce(children, (children) => {
    //children.props.children[2].props.children.props.children.splice(1, 1)
  });
}
